module.exports = __webpack_public_path__ + "img/2_1.ce601c76.jpg";